import(/* webpackMode: "eager" */ "/home/hyrelancer_frontend/hyrelancer/src/app/(public)/customer-workflow/page.jsx");
